var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton-wrapper"},_vm._l((_vm.rows),function(index){return _c('div',{key:index,staticClass:"skeleton-line",class:{ short: _vm.isShort }})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }